/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import Header from "./header";
import { Helmet } from "react-helmet";
import Footer from "./footer";
import "./layout.css";

const Layout = ({ children, series }) => {
  let seriesComponents = "";
  if (series) {
    seriesComponents = series.map(item => item);
  }

  return (
    <>
      <Helmet>
        <link rel="preload" href="/Alegreya-Regular.ttf" as="font" />
        <link rel="preload" href="/Alegreya-Bold.ttf" as="font" />
      </Helmet>
      <Header></Header>
      {/* <hr></hr> */}
      <main className="container main-content">
        <section>{children}</section>
        {series && (
          <section className="container series-content">
            <div>Algunas series que te pueden interesar:</div>
            <div className="all-series-container">{seriesComponents}</div>
          </section>
        )}
      </main>
      <Footer></Footer>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
